import AsyncLoader from 'commons/components/AsyncLoader';

export * from './constants';
export { contentSegmentsRoutes } from './routes';
export { SegmentsLayout } from './SegmentsLayout';
export default AsyncLoader(() => import('./Segments'));
